module.exports = __webpack_public_path__ + "458839dae1f9753fc087fe383017bfbb.svg";